<router-outlet></router-outlet>

<footer class="footer">
  <div>
    <span>&copy; 2020 Speech Analytics v1.0.0. </span>
  </div>
</footer>

<app-loading></app-loading>